import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";
import { ARTIFACT_CONTROLS } from "./constants";

/**
 * The roster before its people arrive.
 *
 * A wide table: a name column that carries the person, then the governed
 * fields. It keeps the header band the real table has, because that band is the
 * part a reader fixes on while the rows fill in.
 */
const COLUMNS = ["w-40", "w-28", "w-24", "w-24", "w-20", "w-20", "w-24"];

export const RulesRosterSkeleton = () => (
  <section
    className="flex min-h-0 flex-1 flex-col"
    role="status"
    aria-label="Loading the roster…"
  >
    <div
      className={cn(
        ARTIFACT_CONTROLS,
        "flex items-center gap-3 bg-surface-sunken",
      )}
      aria-hidden
    >
      <Skeleton className="h-3 w-32" />
      <Skeleton className="h-3 w-56" />
    </div>
    <div aria-hidden className="min-h-0 flex-1 overflow-hidden">
      <Stack
        gap={0}
        align="stretch"
        direction="row"
        className="flex items-center gap-3 border-b border-line bg-surface-sunken px-3 py-2"
      >
        {COLUMNS.map((width, index) => (
          <Skeleton
            key={index}
            className={cn("h-3 shrink-0 opacity-70", width)}
          />
        ))}
      </Stack>
      {Array.from({ length: 30 }, (_, row) => (
        <Stack
          gap={0}
          align="stretch"
          direction="row"
          key={row}
          className="flex items-center gap-3 border-b border-line px-3 py-2"
        >
          {COLUMNS.map((width, index) => (
            <Skeleton key={index} className={cn("h-3 shrink-0", width)} />
          ))}
        </Stack>
      ))}
    </div>
  </section>
);
